import React, { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

export const ThemeContext = createContext();

const themes = {
  light: {
    name: "light",
    background: "#f6f8fb",
    surface: "#ffffff",
    surfaceAlt: "#eef3f8",
    border: "#d8e1ea",
    textColor: "#172033",
    mutedText: "#5f6f86",
    primaryColor: "#1f6feb",
    primaryHover: "#185abc",
    accentColor: "#0f766e",
    headerFooterBackground: "#ffffff",
    headerColor: "#172033",
    h2Color: "#172033",
    segmentBackground: "#ffffff",
    cardBackground: "#ffffff",
    cardTextColor: "#172033",
    buttonBackground: "#1f6feb",
    buttonTextColor: "#ffffff",
    shadow: "0 18px 45px rgba(23, 32, 51, 0.1)",
  },
  dark: {
    name: "dark",
    background: "#0f172a",
    surface: "#111c31",
    surfaceAlt: "#17233a",
    border: "#2b3a55",
    textColor: "#eef4ff",
    mutedText: "#a8b5c7",
    primaryColor: "#60a5fa",
    primaryHover: "#93c5fd",
    accentColor: "#5eead4",
    headerFooterBackground: "#0b1220",
    headerColor: "#eef4ff",
    h2Color: "#eef4ff",
    segmentBackground: "#111c31",
    cardBackground: "#17233a",
    cardTextColor: "#eef4ff",
    buttonBackground: "#60a5fa",
    buttonTextColor: "#08111f",
    shadow: "0 18px 45px rgba(0, 0, 0, 0.28)",
  },
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [themeColors, setThemeColors] = useState(themes.light);

  useEffect(() => {
    const savedTheme = Cookies.get("theme");
    const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;

    if (savedTheme && themes[savedTheme]) {
      setTheme(savedTheme);
      setThemeColors(themes[savedTheme]);
    } else if (prefersDark) {
      setTheme("dark");
      setThemeColors(themes.dark);
    }
  }, []);

  useEffect(() => {
    setThemeColors(themes[theme]);
    Cookies.set("theme", theme, { expires: 30 });
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, themeColors }}>
      {children}
    </ThemeContext.Provider>
  );
};
